import type { PlcManufacturerCodeLibrary } from "./types";

export const honeywellCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "honeywell",
  manufacturer_name: "Honeywell",
  codes: [
    {
      id: "honeywell-ceplc-controller-diagnostics",
      manufacturer_id: "honeywell",
      series_id: "honeywell-controledge-plc",
      model: null,
      code: "CONTROLLER DIAGNOSTICS",
      code_type: "Controller Diagnostic",
      title_ar: "ControlEdge PLC controller diagnostic",
      description_ar: "ControlEdge PLC يعتمد أدوات تشخيص وصيانة ضمن بيئة Honeywell؛ الكود/الحدث التفصيلي لازم ينقرأ من المشروع أو منصة الدعم لنفس الإصدار.",
      symptoms: ["Controller alarm/fault", "حالة تشغيل غير طبيعية"],
      causes: ["Hardware/configuration/communication condition حسب الحدث الفعلي"],
      checks: [
        {
          step: 1,
          action: "سجل اسم الحدث والـtimestamp والـmodule من بيئة ControlEdge قبل Reset.",
          expected: "الحدث محدد بمصدر واضح.",
          faulty: "الـfault يتم مسحه قبل توثيقه.",
        }
      ],
      solutions: ["عالج الحدث حسب إصدار ControlEdge PLC ودليل المشروع.", "إذا الوثيقة التفصيلية تتطلب حساب دعم، لا تستبدلها بكود من شركة ثانية."],
      severity: "عالية",
      source_title: "Honeywell ControlEdge PLC product documentation",
      source_section: "ControlEdge PLC diagnostics / maintenance workflow",
      keywords: ["Honeywell", "ControlEdge PLC", "diagnostic"],
    },
    {
      id: "honeywell-ceiox-channel-diagnostic",
      manufacturer_id: "honeywell",
      series_id: "honeywell-controledge-plc",
      model: null,
      code: "CE-IOX CHANNEL ERROR DIAGNOSIS",
      code_type: "I/O Diagnostic",
      title_ar: "CE-IOX channel error diagnosis",
      description_ar: "Honeywell CE-IOX يوفر Error diagnosis لكل channel ومتكامل حالياً ويا ControlEdge PLC وControlEdge Discrete PLC.",
      symptoms: ["قناة I/O تبين diagnostic", "قراءة أو خرج قناة مو طبيعي"],
      causes: ["خطأ بالقناة أو wiring/sensor/actuator", "I/O module diagnostic active"],
      checks: [
        {
          step: 1,
          action: "حدد رقم الموديول والقناة من I/O diagnostics.",
          expected: "القناة بدون diagnostic active.",
          faulty: "نفس القناة تبقى faulted.",
        }
      ],
      solutions: ["افحص الحقل والقناة والموديول حسب نوع I/O.", "لا تبدل موديولات أثناء حالة خطرة بدون عزل."],
      severity: "عالية",
      source_title: "Honeywell CE-IOX I/O Module Series",
      source_section: "Error diagnosis on each channel",
      keywords: ["Honeywell", "CE-IOX", "channel diagnostic"],
    },
    {
      id: "honeywell-cediscrete-iox-diagnostic",
      manufacturer_id: "honeywell",
      series_id: "honeywell-controledge-discrete",
      model: null,
      code: "CE-IOX CHANNEL ERROR DIAGNOSIS",
      code_type: "I/O Diagnostic",
      title_ar: "ControlEdge Discrete PLC I/O channel diagnostic",
      description_ar: "ControlEdge Discrete PLC يدعم CE-IOX اللي يوفر تشخيص أخطاء لكل قناة.",
      symptoms: ["I/O fault", "قناة ما تشتغل"],
      causes: ["Channel/wiring/module fault"],
      checks: [
        {
          step: 1,
          action: "اقرأ channel diagnostic من بيئة الكنترولر.",
          expected: "القناة Healthy.",
          faulty: "القناة Faulted/Diagnostic active.",
        }
      ],
      solutions: ["عالج field wiring أو module حسب التشخيص."],
      severity: "عالية",
      source_title: "Honeywell ControlEdge Discrete PLC / CE-IOX product documentation",
      source_section: "CE-IOX supported; per-channel error diagnosis",
      keywords: ["Honeywell", "ControlEdge Discrete PLC", "CE-IOX"],
    },
    {
      id: "honeywell-pcd-web-monitor",
      manufacturer_id: "honeywell",
      series_id: "honeywell-controledge-pcd",
      model: null,
      code: "PCD STATUS / WEB MONITOR",
      code_type: "Controller Diagnostic",
      title_ar: "ControlEdge PCD status monitoring",
      description_ar: "ControlEdge PCD يدعم Integrated Web Server لمراقبة الحالات والبيانات، وهو مسار رسمي لتحديد الحالة قبل تفسير fault بالتفصيل.",
      symptoms: ["Controller status غير طبيعي", "Communication أو I/O status يحتاج فحص"],
      causes: ["CPU/I/O/communication condition حسب الحالة المسجلة"],
      checks: [
        {
          step: 1,
          action: "اقرأ الحالة من Engineering Tool/Web Server وسجلها.",
          expected: "الحالات طبيعية ومستقرة.",
          faulty: "تظهر حالة Fault/Alarm أو جهاز غير متصل.",
        }
      ],
      solutions: ["عالج الجهاز أو الاتصال اللي يظهر بالحالة.", "استخدم دليل إصدار PCD للرمز التفصيلي إن وجد."],
      severity: "متوسطة",
      source_title: "Honeywell ControlEdge PCD product documentation",
      source_section: "Integrated Web Server for monitoring and control",
      keywords: ["Honeywell", "ControlEdge PCD", "status", "web server"],
    },
  ],
};
